import { useEffect, useState } from 'react';
import { MOBILE_BREAKPOINT } from 'App/constants/breakpoints';

interface UseResponsiveResult {
  isMobile: boolean;
  isDesktop: boolean;
}

function useResponsive(
  breakpoint: number = MOBILE_BREAKPOINT,
): UseResponsiveResult {
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth < breakpoint,
  );

  useEffect(() => {
    const handleResize = () => {
      const newIsMobile = window.innerWidth < breakpoint;
      setIsMobile((prevIsMobile) => {
        if (prevIsMobile !== newIsMobile) {
          return newIsMobile;
        }
        return prevIsMobile;
      });
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return {
    isMobile,
    isDesktop: !isMobile,
  };
}

export default useResponsive;
